import type { ReactNode } from "react";
import { ColorDot, FORMAT_TOOLTIP_COLUMN_WIDTH } from "~/components/charts";
import { Text } from "~/components/text";
import { formatBucketDate } from "~/utils/formatting";

export interface FormatMatrixColumn {
  key: string;
  label: string;
  colorClassName?: string;
  color?: string;
}

export interface FormatMatrixTooltipProps {
  date: string;
  columns: FormatMatrixColumn[];
  /** Metric rows: label cell plus one cell per column in the shared grid. */
  children: ReactNode;
}

/** Matrix shell for bundled tooltips; column width matches estimateFormatTooltipWidth. */
export const FormatMatrixTooltip = ({
  date,
  columns,
  children,
}: FormatMatrixTooltipProps) => (
  <div className="rounded-lg bg-secondary-800 px-3 py-2 text-xs text-white shadow-xl">
    <div
      className="grid gap-x-3 gap-y-1"
      style={{
        gridTemplateColumns: `auto repeat(${columns.length}, minmax(${FORMAT_TOOLTIP_COLUMN_WIDTH}px, 1fr))`,
      }}
    >
      <Text as="div" variant="tooltip">
        {formatBucketDate(date)}
      </Text>
      {columns.map((column) => (
        <div
          key={column.key}
          className="grid justify-items-end gap-0.5 font-semibold"
        >
          <ColorDot
            className={column.colorClassName}
            style={
              column.colorClassName
                ? undefined
                : { backgroundColor: column.color }
            }
            ring
          />
          <Text as="span" variant="tooltip" className="text-right">
            {column.label}
          </Text>
        </div>
      ))}
      {children}
    </div>
  </div>
);
